import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import { DrillDown, PlotBand } from "../statistic_components/common_metadata.js"
import { ErrorBoundary } from "../components/error_boundary.js"
import React from "react";
interface BulletChartProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: BulletChartState
}

export class BulletChart extends React.Component<BulletChartProps, any>{
    constructor(props) {
        super(props);
        this.state = {};
    }

    getChartConfig = () => {
        var config: any;
        config = {
            legend: {
                visible: false
            },
            series: [{
                type: "bullet",
                data: [[30]]
            }],
            categoryAxis: {
                majorGridLines: {
                    visible: false
                },
                majorTicks: {
                    visible: false
                }
            },
            valueAxis: [{
                majorGridLines: {
                    visible: false
                },
                minorTicks: {
                    visible: true
                }
            }],
            tooltip: {
                visible: true,
                template: "#=value.current#"
            }
        };
        var plotBands = this.props.metadataSettings.plotBands;
        if (!plotBands || !Array.isArray(plotBands)) {
            config.valueAxis[0].plotBands = [
                { from: 0, to: 50, color: "yellow", opacity: 0.3 },
                { from: 50, to: 80, color: "orange", opacity: 0.3 },
                { from: 80, to: 100, color: "red", opacity: 0.3 }];
        }
        else {
            config.valueAxis[0].plotBands = plotBands;
        }
        var color = this.props.metadataSettings.color;

        if (color && color != "") {
            config.series[0].color = color;
        }

        return config;
    }
    handleDataChange = (data) => {
        this.setState({ values: data });
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.metadataSettings != nextProps.settings || this.state.values != nextState.values || this.props.queryParameter != nextProps.quaryParameter;
    }
    handleSeriesClick = (value) => {
        if (this.props.metadataSettings.drilldown && (this.props.metadataSettings.drilldown.statisticId) && this.props.metadataSettings.drilldown.statisticId != "") {
            var newObj: any = $.extend({}, this.props.queryParameter);
            newObj[this.props.metadataSettings.drilldown.destField] = value[this.props.metadataSettings.drilldown.sourceField];
            newObj._hideInputControls = this.props.metadataSettings.drilldown.hideInputControls;
            var params = newObj;
            this.props.context.drillDownObject.requestDrillDown(params, this.props.metadataSettings.drilldown.statisticId, value);
        }
    }
    getBulletChart = (value, index) => {
        var config = this.getChartConfig();
        config.valueAxis[0].min = 0;
        config.valueAxis[0].max = this.props.metadataSettings.maxPerCent || 100;

        var range = value[this.props.metadataSettings.maxField] - value[this.props.metadataSettings.minField];
        var deltaFromMin = value[this.props.metadataSettings.currentValueField] - value[this.props.metadataSettings.minField];
        var percent: any = 100 / range * deltaFromMin;

        let valueFormat = this.props.metadataSettings.valueFormat;
        if (valueFormat) {
            percent = kendo.toString(percent, valueFormat);
        }

        config.series[0].data[0] = [percent];
        return (<div key={index} onClick={this.handleSeriesClick.bind(this, value)} >{value[this.props.metadataSettings.descriptionField]}<react_components.KendoSimpleChart settings={config} height="50px" /></div>)
    }

    render() {
        var charts = [];

        if (Array.isArray(this.state.values)) {
            charts = this.state.values.map(this.getBulletChart);
        }
        return (
            <react_components.ReactColumn width={this.props.metadataSettings.width} >
                <ErrorBoundary>
                    <react_components.ReactDataPager uid={this.props.uid} context={this.props.context} titel={this.props.metadataSettings.title} dataUrl={this.props.metadataSettings.dataUrl} enablePagging={true} pageSize={Number(this.props.metadataSettings.pageSize)} queryParameter={this.props.queryParameter} onVisibleDataChange={this.handleDataChange}>
                        {charts}
                    </react_components.ReactDataPager>
                </ErrorBoundary>
            </react_components.ReactColumn>
        )
    }
};

export class BulletChartState extends propertyTypes.BaseComponentProps {
    private minFieldMetadata = new propertyTypes.ColumnProperty("minField", "Min", "dataUrl");
    public minField: string;

    private maxFieldMetadata = new propertyTypes.ColumnProperty("maxField", "Max", "dataUrl");
    public maxField: string;

    private currentValueFieldMetadata = new propertyTypes.ColumnProperty("currentValueField", "Value", "dataUrl");
    public currentValueField: string;

    private descriptionFieldMetadata = new propertyTypes.ColumnProperty("descriptionField", "Description", "dataUrl");
    public descriptionField: string;

    private maxPerCentMetadata = new propertyTypes.TextProperty("maxPerCent", "Max %");
    public maxPerCent: string;

    private pageSizeMetadata = new propertyTypes.TextProperty("pageSize", "Page size");
    public pageSize: string;

    private titelMetadata = new propertyTypes.TranslatableTextProperty("title", "Title");
    public title: string;

    private colorMetadata = new propertyTypes.TextProperty("color", "Color");
    public color: string;

    private valueFormatMetadata = new propertyTypes.TextProperty("valueFormat", "Value format");
    public valueFormat: string;

    private dataUrlMetadata = new propertyTypes.ServiceSelectorProperty("dataUrl", "Data url", false, null);
    public dataUrl: string;

    private drilldownMetadata = new propertyTypes.ObjectPropertyExt("drilldown", "Drilldown")
        .addStateImplementation("drillDown", DrillDown);
    public drilldown: DrillDown;

    private plotBandMetadata = new propertyTypes.ObjectListPropertyExt("plotBands", "Plot bands").addStateImplementation("default", PlotBand);
    public plotBands: PlotBand[];

    private bulletMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.bulletMetadataAll = baseMetaData.concat([this.minFieldMetadata, this.maxFieldMetadata, this.currentValueFieldMetadata, this.descriptionFieldMetadata, this.maxPerCentMetadata, this.pageSizeMetadata, this.titelMetadata, this.colorMetadata, this.valueFormatMetadata, this.dataUrlMetadata, this.drilldownMetadata, this.plotBandMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.bulletMetadataAll;
    }
}